import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Delivery from "@/components/Delivery";
import Promos from "@/components/Promos";
import FindUs from "@/components/FindUs";
import Notify from "@/components/Notify";
import Footer from "@/components/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const onClick = (e) => {
      const a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (!href || href.length < 2) return;
      const el = document.querySelector(href);
      if (el) {
        e.preventDefault();
        lenis.scrollTo(el);
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="relative min-h-screen overflow-x-clip bg-ink text-cream">
      <div className="grain" aria-hidden="true" />
      <Hero />
      <Marquee />
      <Delivery />
      <Promos />
      <FindUs />
      <Notify />
      <Footer />
    </div>
  );
}

export default App;
